/**
 * Resuable function that will create an object for POST body payload.
 * @param {object} params Any object with key/value pair.
 * @returns Object
 */
export const makePostBody = params => {
  let body = {};
  if (params !== undefined) {
    Object.keys(params).forEach(key => {
      if (params[key] != null) {
        // handle array values
        if (Array.isArray(params[key])) {
          body[key] = params[key].join(",");
        } else {
          body[key] = params[key];
        }
      }
    });
  }

  return body;
};
